export const steps = [
	'Basic Information',
	'Work & Personal Preferences',
	'Travel Information',
	'Review',
];

export const stateOptions = [
	{ id: 'AL', display: 'Alabama' },
	{ id: 'AK', display: 'Alaska' },
	{ id: 'AZ', display: 'Arizona' },
	{ id: 'AR', display: 'Arkansas' },
	{ id: 'CA', display: 'California' },
	{ id: 'CO', display: 'Colorado' },
	{ id: 'CT', display: 'Connecticut' },
	{ id: 'DE', display: 'Delaware' },
	{ id: 'FL', display: 'Florida' },
	{ id: 'GA', display: 'Georgia' },
	{ id: 'HI', display: 'Hawaii' },
	{ id: 'ID', display: 'Idaho' },
	{ id: 'IL', display: 'Illinois' },
	{ id: 'IN', display: 'Indiana' },
	{ id: 'IA', display: 'Iowa' },
	{ id: 'KS', display: 'Kansas' },
	{ id: 'KY', display: 'Kentucky' },
	{ id: 'LA', display: 'Louisiana' },
	{ id: 'ME', display: 'Maine' },
	{ id: 'MD', display: 'Maryland' },
	{ id: 'MA', display: 'Massachusetts' },
	{ id: 'MI', display: 'Michigan' },
	{ id: 'MN', display: 'Minnesota' },
	{ id: 'MS', display: 'Mississippi' },
	{ id: 'MO', display: 'Missouri' },
	{ id: 'MT', display: 'Montana' },
	{ id: 'NE', display: 'Nebraska' },
	{ id: 'NV', display: 'Nevada' },
	{ id: 'NH', display: 'New Hampshire' },
	{ id: 'NJ', display: 'New Jersey' },
	{ id: 'NM', display: 'New Mexico' },
	{ id: 'NY', display: 'New York' },
	{ id: 'NC', display: 'North Carolina' },
	{ id: 'ND', display: 'North Dakota' },
	{ id: 'OH', display: 'Ohio' },
	{ id: 'OK', display: 'Oklahoma' },
	{ id: 'OR', display: 'Oregon' },
	{ id: 'PA', display: 'Pennsylvania' },
	{ id: 'RI', display: 'Rhode Island' },
	{ id: 'SC', display: 'South Carolina' },
	{ id: 'SD', display: 'South Dakota' },
	{ id: 'TN', display: 'Tennessee' },
	{ id: 'TX', display: 'Texas' },
	{ id: 'UT', display: 'Utah' },
	{ id: 'VT', display: 'Vermont' },
	{ id: 'VA', display: 'Virginia' },
	{ id: 'WA', display: 'Washington' },
	{ id: 'WV', display: 'West Virginia' },
	{ id: 'WI', display: 'Wisconsin' },
	{ id: 'WY', display: 'Wyoming' },
];

export const airlineOptions = [
	{ id: 'alaskan', display: 'Alaskan' },
	{ id: 'american', display: 'American' },
	{ id: 'delta', display: 'Delta' },
	{ id: 'frontier', display: 'Frontier' },
	{ id: 'klm', display: 'KLM/Northwest' },
	{ id: 'southwest', display: 'Southwest' },
	{ id: 'united', display: 'United' },
	{ id: 'virgin', display: 'Virgin' },
];

export const shirtSizeOptions = [
	{ id: 'xs', display: 'XS' },
	{ id: 's', display: 'S' },
	{ id: 'm', display: 'M' },
	{ id: 'l', display: 'L' },
	{ id: 'xl', display: 'XL' },
	{ id: 'xxl', display: 'XXL' },
];

export const shoeSizeOptions = [
	{ id: '5', display: '5' },
	{ id: '5.5', display: '5.5' },
	{ id: '6', display: '6' },
	{ id: '6.5', display: '6.5' },
	{ id: '7', display: '7' },
	{ id: '7.5', display: '7.5' },
	{ id: '8', display: '8' },
	{ id: '8.5', display: '8.5' },
	{ id: '9', display: '9' },
	{ id: '9.5', display: '9.5' },
	{ id: '10', display: '10' },
	{ id: '10.5', display: '10.5' },
	{ id: '11', display: '11' },
	{ id: '11.5', display: '11.5' },
	{ id: '12', display: '12' },
	{ id: '12.5', display: '12.5' },
	{ id: '13', display: '13' },
	{ id: '13.5', display: '13.5' },
	{ id: '14', display: '14' },
	{ id: '14.5', display: '14.5' },
	{ id: '15', display: '15' },
];
